import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ITumCredentials } from './tumCredentials';
import { ITumCredentialsFormValues } from './tumCredentialsFormValues';
import { ITumCredentialsUpsert } from './tumCredentialsUpsert';

export default class TumCredentialsModelHelper {
    public static createFormValues = (entry : ITumCredentials | null) : ITumCredentialsFormValues => {
        if (!entry) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            clientId: '',
            clientSecret: '',
            isActive: true,
        };

        return {
            id: entry.id,
            guid: entry.guid,
            code: entry.code,
            name: entry.name,
            clientId: entry.clientId,
            clientSecret: entry.clientSecret,
            isActive: entry.isActive,
        };
    };

    public static createUpsert = (formValues : ITumCredentialsFormValues) : ITumCredentialsUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            clientId: formValues.clientId,
            clientSecret: formValues.clientSecret,
            organizationIds: [],
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ITumCredentialsFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        clientId: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        clientSecret: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
